import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useAppSelector } from '../app/hooks';
import { getMember } from '../libs/polygon-ordering/src/selectors';
import LoyaltyWrapper from '../components/LoyaltyWrapper';
import RegistrationVerifyScreen from './RegistrationVerify';

const PrivateRoute: React.FC<{
  exact: boolean;
  path: string;
  component: React.ElementType;
  hideHero?: boolean;
}> = ({ component: Component, path, exact, hideHero }) => {
  const member = useAppSelector(getMember);

  const renderContent = (props: any) => {
    if (!member) {
      return <Redirect to="/" />;
    }

    if (!member.verified) {
      return (
        <LoyaltyWrapper>
          <RegistrationVerifyScreen showContinueButton={false} internalRedirect />
        </LoyaltyWrapper>
      );
    }

    return (
      <LoyaltyWrapper hideHero={hideHero}>
        <Component {...props} />
      </LoyaltyWrapper>
    );
  };

  return <Route path={path} exact={exact} render={renderContent} />;
};

export default PrivateRoute;
